import { axiosClouth, axiosClouthFileUpload } from "../../config/apiConfig";

import {
  CREATE_PRODUCT_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  FIND_PRODUCT_BY_ID_FAILURE,
  FIND_PRODUCT_BY_ID_REQUEST,
  FIND_PRODUCT_BY_ID_SUCCESS,
  FIND_PRODUCTS_FAILURE,
  FIND_PRODUCTS_REQUEST,
  FIND_PRODUCTS_SUCCESS,
  UPDATE_IMAGES_EXTRADATA_FAILURE,
  UPDATE_IMAGES_EXTRADATA_REQUEST,
  UPDATE_IMAGES_EXTRADATA_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPLOAD_IMAGES_FAILURE,
  UPLOAD_IMAGES_REQUEST,
  UPLOAD_IMAGES_SUCCESS,
} from "./ActionType";

export const findProducts = (reqData) => async (dispatch) => {
  //const {auth}=useSelector(store=>store)
  dispatch({ type: FIND_PRODUCTS_REQUEST });

  const {
    colors,
    sizes,
    minPrice,
    maxPrice,
    minDiscount,
    category,
    stock,
    sort,
    pageNumber,
    pageSize,
  } = reqData;

  try {
    const { data } = await axiosClouth.get(
      `api/products?category=${category}&color=${colors}&size=${sizes}&minPrice=${minPrice}&maxPrice=${maxPrice}&minDiscount=${minDiscount}&sort=${sort}&stock=${stock}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${reqData.reqJWT}`,
        },
      }
    );
    //console.log("product data ", data);
    dispatch({ type: FIND_PRODUCTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FIND_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const findProducts2 = (reqData) => async (dispatch) => {
  //const {auth}=useSelector(store=>store)
  dispatch({ type: FIND_PRODUCTS_REQUEST });

  const {
    colors,
    sizes,
    minPrice,
    maxPrice,
    minDiscount,
    category,
    stock,
    sort,
    pageNumber,
    pageSize,
  } = reqData;

  try {
    const { data } = await axiosClouth.get(
      `api/products2?category=${category}&color=${colors}&size=${sizes}&minPrice=${minPrice}&maxPrice=${maxPrice}&minDiscount=${minDiscount}&sort=${sort}&stock=${stock}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${reqData.reqJWT}`,
        },
      }
    );
    //console.log("product data ", data);
    dispatch({ type: FIND_PRODUCTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FIND_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const findProductsBYId = (reqData) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCT_BY_ID_REQUEST });

  const { productById } = reqData;

  try {
    const { data } = await axiosClouth.get(`api/products/id/${productById}`, {
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    });
    //console.log("Data- ", data);
    dispatch({ type: FIND_PRODUCT_BY_ID_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FIND_PRODUCT_BY_ID_FAILURE, payload: error.message });
  }
};

export const createProduct = (product) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PRODUCT_REQUEST });
    //console.log(product);
    const { data } = await axiosClouth.post(`/api/admin/products/`, product.productData,{
      headers: {
        Authorization: `Bearer ${product.reqJWT}`,
      },
    });

    dispatch({
      type: CREATE_PRODUCT_SUCCESS,
      payload: data,
    });

    //console.log("created product ", data);
  } catch (error) {
    dispatch({
      type: CREATE_PRODUCT_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

const uploadImageRequest=()=>({type:UPLOAD_IMAGES_REQUEST});
const uploadImageSuccess=(data)=>({type:UPLOAD_IMAGES_SUCCESS, payload:data});
const uploadImageFailure=(error)=>({type:UPLOAD_IMAGES_FAILURE, payload:error});

export const uploadImage = (reqData) => async (dispatch) => {
  try{
    dispatch(uploadImageRequest())
    const {data}=await axiosClouthFileUpload.post(`/api/admin/products/productMainImageUpload?productId=${reqData.productId}`,reqData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data); 
    });
    dispatch(uploadImageSuccess(data));
  }catch (error) {
    dispatch(uploadImageFailure(error.message))
  }
}

const uploadAdFirstImageRequest=()=>({type:UPLOAD_IMAGES_REQUEST});
const uploadAdFirstImageSuccess=(data)=>({type:UPLOAD_IMAGES_SUCCESS, payload:data});
const uploadAdFirstImageFailure=(error)=>({type:UPLOAD_IMAGES_FAILURE, payload:error});

export const uploadAdFirstImage = (reqData) => async (dispatch) => {
  try{
    dispatch(uploadAdFirstImageRequest())
    const {data}=await axiosClouthFileUpload.post(`/api/admin/products/productExtraImageUpload?productId=${reqData.productId}`,reqData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data)
    });
    dispatch(uploadAdFirstImageSuccess(data));
  }catch (error) {
    dispatch(uploadAdFirstImageFailure(error.message))
  }
}

const uploadAdSecondImageRequest=()=>({type:UPLOAD_IMAGES_REQUEST});
const uploadAdSecondImageSuccess=(data)=>({type:UPLOAD_IMAGES_SUCCESS, payload:data});
const uploadAdSecondImageFailure=(error)=>({type:UPLOAD_IMAGES_FAILURE, payload:error});

export const uploadAdSecondImage = (reqData) => async (dispatch) => {
  try{
    dispatch(uploadAdSecondImageRequest())
    const {data}=await axiosClouthFileUpload.post(`/api/admin/products/productExtraImageUploadSecond?productId=${reqData.productId}`,reqData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data)
    });
    dispatch(uploadAdSecondImageSuccess(data));
  }catch (error) {
    dispatch(uploadAdSecondImageFailure(error.message))
  }
}

const uploadAdThirdImageRequest=()=>({type:UPLOAD_IMAGES_REQUEST});
const uploadAdThirdImageSuccess=(data)=>({type:UPLOAD_IMAGES_SUCCESS, payload:data});
const uploadAdThirdImageFailure=(error)=>({type:UPLOAD_IMAGES_FAILURE, payload:error});

export const uploadAdThirdImage = (reqData) => async (dispatch) => {
  try{
    dispatch(uploadAdThirdImageRequest())
    const {data}=await axiosClouthFileUpload.post(`/api/admin/products/productExtraImageUploadThird?productId=${reqData.productId}`,reqData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data)
    });
    dispatch(uploadAdThirdImageSuccess(data));
  }catch (error) {
    dispatch(uploadAdThirdImageFailure(error.message))
  }
}

const uploadAdFourthImageRequest=()=>({type:UPLOAD_IMAGES_REQUEST});
const uploadAdFourthImageSuccess=(data)=>({type:UPLOAD_IMAGES_SUCCESS, payload:data});
const uploadAdFourthImageFailure=(error)=>({type:UPLOAD_IMAGES_FAILURE, payload:error});

export const uploadAdFourthImage = (reqData) => async (dispatch) => {
  try{
    dispatch(uploadAdFourthImageRequest())
    const {data}=await axiosClouthFileUpload.post(`/api/admin/products/productExtraImageUploadFourth?productId=${reqData.productId}`,reqData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data)
    });
    dispatch(uploadAdFourthImageSuccess(data));
  }catch (error) {
    dispatch(uploadAdFourthImageFailure(error.message))
  }
}

const updtProdcutImagExtDataRequest=()=>({type:UPDATE_IMAGES_EXTRADATA_REQUEST});
const updtProdcutImagExtDataSuccess=(data)=>({type:UPDATE_IMAGES_EXTRADATA_SUCCESS, payload:data});
const updtProdcutImagExtDataFailure=(error)=>({type:UPDATE_IMAGES_EXTRADATA_FAILURE, payload:error});

export const updtProdcutImagExtData = (reqData) => async (dispatch) => {
  try{
    dispatch(updtProdcutImagExtDataRequest())
    const {response}=await axiosClouth.post(`/api/admin/products/updateProductImageOtherData?productId=${reqData.productId}`,reqData.productExtData,{
      headers: {
        Authorization: `Bearer ${reqData.reqJWT}`,
      },
    }).then((res)=>{
      alert(res.data.message);
    });
    const data=response.message;
    dispatch(updtProdcutImagExtDataSuccess(data));
  }catch (error) {
    dispatch(updtProdcutImagExtDataFailure(error.message));
  }
}

export const updateProduct = (product) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    const { data } = await axiosClouth.put(
      `/api/admin/products/${product.productId}`,
      product
    );

    dispatch({
      type: UPDATE_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PRODUCT_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteProduct = (productId) => async (dispatch) => {
  //console.log("delete product action",productId)
  try {
    dispatch({ type: DELETE_PRODUCT_REQUEST });

    let {data}=await axiosClouth.delete(`/api/admin/products/${productId}/delete`);

    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: data,
    });

    //console.log("product delte ",data)
  } catch (error) {
    //console.log("catch error ",error)
    dispatch({
      type: DELETE_PRODUCT_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};